import React from "react";
import Loader from "react-loader-spinner";
import { useMenuBestOf } from "../../context/MenuBestOf";
import LayoutItem from "./LayoutItem";
import { makeStyles, useTheme } from "@material-ui/core";

import "./Layout.css"; // Let that file !!!!!!!!!!!!

const useStyles = makeStyles((theme) => ({
  fetchHeaderGroupMenu: {
    display: "flex",
    justifyContent: "center",
    marginTop: "50px"
  },
}));

const Layout = () => {
  const classes = useStyles();
  const theme = useTheme();
  // const {dispatch} = useBestOf();
  // const { dispatch: dispatchMenu, state: stateMenu} = useMenuBestOf();
  const { state: stateMenu} = useMenuBestOf();
  return (
    <>
      {(stateMenu.isLoading > 0) 
      ?
        <div className={classes.fetchHeaderGroupMenu}>
          <Loader type="Oval" height={40} width={40} color={theme.palette.primary.dark}/>
        </div>
      :
        <div className="container-layout-menu">
          { (!stateMenu.allBestOf || stateMenu.allBestOf.length === 0) && <p>Aucun Best of sauvegardé</p>}
          {stateMenu.allBestOf.map((bestof, index) => {
            return (
              <LayoutItem key={index} bestof={bestof} />
            )
          })}
        </div>
      }
    </>
  );
};

export default Layout;